import React from "react";

type LoaderWithLabelProps = {
    label: string;
};

export const LoaderWithLabel: React.FC<LoaderWithLabelProps> = ({ label }) => {
    return (
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{label}:</label>
            <div className="flex gap-1.5 items-center h-7">
                <div className="w-3 h-3 rounded-full animate-pulse bg-blue-500"></div>
                <div className="w-3 h-3 rounded-full animate-pulse bg-blue-500"></div>
                <div className="w-3 h-3 rounded-full animate-pulse bg-blue-500"></div>
            </div>
        </div>
    );
};
